import { Component, OnInit, Inject } from "@angular/core";

import { IGroup } from "src/app/interfaces/group";
import { SoundEnum } from "src/app/enums/sound.enum";
import { TranslateService } from "@ngstack/translate";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ErrorsService } from "src/app/services/common/errors.service";
import { SnackBarService } from "src/app/services/common/snackBar.service";
import { MarkManagementService } from "src/app/services/http/business/markManagement/mark-management.service";
import { IError } from "src/app/interfaces/error.interface";

@Component({
  selector: 'app-mark-classification-type-entry',
  templateUrl: './mark-classification-type-entry.component.html',
  styleUrls: ['./mark-classification-type-entry.component.css']
})
export class MarkClassificationTypeEntryComponent implements OnInit {

  param: any;
  errorList: IError[] = [];
  errObject: any;
  form: FormGroup;
  isOwner: boolean;
  cCode: string;
  errors = new Array();

  constructor(
    private fb: FormBuilder,
     private snackBar: SnackBarService,
    public translate: TranslateService,
    private errorService: ErrorsService,
    private markManagementService: MarkManagementService,
    private dialogRef: MatDialogRef<MarkClassificationTypeEntryComponent>,
    @Inject(MAT_DIALOG_DATA) public data:any
  ) {}

  ngOnInit() {
    this.createForm();
  }

  createForm() {
    this.form = this.fb.group({
      Title: [
        this.data && this.data.Title ? this.data.Title.toString() : null,
        Validators.compose([Validators.required, Validators.maxLength(70)])
      ],
      Code: [
        this.data && this.data.Code ? this.data.Code.toString() : "",
        Validators.compose([Validators.maxLength(30),Validators.required])
      ],
      OrderCulomnNumber: [
        this.data && this.data.OrderCulomnNumber ? this.data.OrderCulomnNumber.toString() : null,
        Validators.compose([Validators.required])
      ],
      IsActive: [
        this.data && this.data.IsActive? this.data.IsActive: true
      ]
    });
  }

  onNoClick() {
    this.dialogRef.close();
  }

  submit(form: IGroup) {
   
    this.errors = new Array();
    if (this.data == null) {
      this.markManagementService.catAdd(form).subscribe(
        () => {
          this.snackBar.OpenSnackBar(
            this.translate.get("success.markTypeCategory", { name: this.translate.get('label.submit') }),
            "ok",
            5000,
            SoundEnum.beep
          );
          this.onNoClick();
        },
        error => {
          // this.errObject = this.errorService.getError(error);
          // this.param = this.errorService.objectError(this.errObject);
          // this.errors = this.errorService.returnError(error);
          this.errorList = this.errorService.getErrorList(error.error);
        }
      );
    }
    if (this.data && this.data.Title) {
      form.Id = this.data.Id;
      this.markManagementService.catEdit(form).subscribe(
        () => {
          this.snackBar.OpenSnackBar(
            this.translate.get("success.markTypeCategory", { name: this.translate.get('label.edit') }),
            "ok",
            5000,
            SoundEnum.beep
          );
          this.dialogRef.close(form);
        },
        error => {
          // this.errObject = this.errorService.getError(error);
          // this.param = this.errorService.objectError(this.errObject);
          // this.errors = this.errorService.returnError(error);
          this.errorList = this.errorService.getErrorList(error.error);
        }
      );
    }
  }
}
